export default "query getPolizzeAnagrafica ($username: String!, $roleCode: String!) {\n    getPolizzeAnagrafica(username: $username, roleCode: $roleCode)\n}";